const STORAGE_KEY = 'twin-tales-instagram-publish-draft';

export function buildInstagramPublishDraft(fields) {
  return {
    videoUrl: fields.videoUrl ?? '',
    caption: fields.caption ?? '',
    coverUrl: fields.coverUrl ?? '',
    shareToFeed: fields.shareToFeed !== false,
    metadataOptimizeLang: fields.metadataOptimizeLang ?? 'en',
    instagramReelsMode: Boolean(fields.instagramReelsMode),
  };
}

export function applyInstagramPublishDraft(draft, setters) {
  if (!draft || typeof draft !== 'object') return;
  const apply = (key, value) => {
    const fn = setters[key];
    if (typeof fn === 'function') fn(value);
  };
  apply('setVideoUrl', draft.videoUrl ?? '');
  apply('setCaption', draft.caption ?? '');
  apply('setCoverUrl', draft.coverUrl ?? '');
  apply('setShareToFeed', draft.shareToFeed !== false);
  apply('setMetadataOptimizeLang', draft.metadataOptimizeLang ?? 'en');
  apply('setInstagramReelsMode', Boolean(draft.instagramReelsMode));
}

export function saveInstagramPublishDraft(draft) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
  } catch {
    /* quota */
  }
}

export function loadInstagramPublishDraft() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearInstagramPublishDraft() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
